import Reveal from "@/components/Reveal";

const chapters = [
  { n: "01", title: "Craft Cocktails", body: "A curated menu of signature drinks built from fresh juices, quality spirits and native Australian botanicals — never a pre-mix in sight." },
  { n: "02", title: "Location Flexibility", body: "Sand, deck, rooftop or boat — the bar comes to you. Fully mobile and at home anywhere along the Sunshine Coast." },
  { n: "03", title: "Full Equipment Setup", body: "Bar, glassware, ice, tools and styling arrive with me. You simply point to the spot and the rest is handled." },
  { n: "04", title: "Event Scalability", body: "From an intimate elopement to a corporate marquee, the service flexes to your guest count and celebration." },
];

const IMG = {
  party: "https://images.unsplash.com/photo-1678895575027-42c28b790963?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxiZWFjaGZyb250JTIwY29ja3RhaWwlMjBwYXJ0eXxlbnwwfHx8fDE3ODUyMzM2NTJ8MA&ixlib=rb-4.1.0&q=85",
  bartender: "https://images.unsplash.com/photo-1563811871195-3e1047be568c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxiYXJ0ZW5kZXIlMjBiZWFjaHxlbnwwfHx8fDE3ODUyMzM2NTJ8MA&ixlib=rb-4.1.0&q=85",
  cocktails: "https://images.unsplash.com/photo-1598994392980-53a7fb033bcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMGNvY2t0YWlscyUyMGx1eHVyeXxlbnwwfHx8fDE3ODUyMzM2NTJ8MA&ixlib=rb-4.1.0&q=85",
};

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-cream py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal>
        <p className="overline text-xs text-coral mb-5">The Approach</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ocean-deep max-w-3xl leading-[1.02] tracking-tight">
          A one-person bar, obsessed with the details.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16 items-start">
        {/* Manifesto chapters */}
        <div className="space-y-10">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="flex gap-6 border-b border-sand pb-8 group">
                <span className="font-serif text-3xl text-coral/70 group-hover:text-coral transition-colors">{c.n}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-ocean-deep mb-2">{c.title}</h3>
                  <p className="text-ocean/80 text-base leading-relaxed max-w-md">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Bento gallery */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:grid-rows-6 md:h-[560px] lg:sticky lg:top-28">
          <Reveal className="md:col-span-8 md:row-span-4" delay={0.1}>
            <img src={IMG.party} alt="Beachfront cocktail party" className="w-full h-64 md:h-full object-cover rounded-2xl" />
          </Reveal>
          <Reveal className="md:col-span-4 md:row-span-3" delay={0.2}>
            <img src={IMG.cocktails} alt="Luxury tropical cocktails" className="w-full h-56 md:h-full object-cover rounded-2xl" />
          </Reveal>
          <Reveal className="md:col-span-4 md:row-span-3" delay={0.3}>
            <div className="w-full h-40 md:h-full rounded-2xl bg-ocean-deep text-white p-5 flex flex-col justify-end">
              <span className="font-serif text-5xl leading-none">100%</span>
              <span className="overline text-[10px] text-coral mt-2">Mobile & self-contained</span>
            </div>
          </Reveal>
          <Reveal className="md:col-span-8 md:row-span-2" delay={0.25}>
            <img src={IMG.bartender} alt="Bartender at work" className="w-full h-56 md:h-full object-cover rounded-2xl" />
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default About;
